"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const epic_react_common_1 = require("epic-react-common");
const epic_alt_utils_1 = __importDefault(require("epic-alt-utils"));
/**
 * PosaRedeemActions
 */
exports.default = epic_alt_utils_1.default(epic_react_common_1.alt, ['getCmsContent', 'validateCode', 'redeemCode', 'track'], ['resetFlow', 'resetErrorCode', 'setPlatform', 'setShowConfirm', 'setPsnCountry']);
//# sourceMappingURL=PosaRedeemActions.js.map